import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientsService } from 'src/app/services/clients/clients.service';
import { CommandesService } from 'src/app/services/commandes/commandes.service';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { AddBoxComponent } from '../../settings/products/windows/add-box/add-box.component';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-commande',
  templateUrl: './add-commande.component.html',
  styleUrls: ['./add-commande.component.css']
})
export class AddCommandeComponent implements OnInit {

  @ViewChild('autoInput') input: any;

  isClicked: Boolean = false
  isSaved: Boolean = true

  palletsData: any[] = []

  order: any = {}

  allFiles: any = []

  // allSocieties: any[] = []
  allPalettes: any[] = []
  selectedPalette: any = null

  selectedVille: string = '';
  // totalCmd: number = 0;
  frais: any = {}

  typesPriority: any = [
    { code: 1, label: "Opération standard", description: "Délai de livraison normal, sans urgence particulière" },
    { code: 2, label: "Opération accélérée", description: "Délai de livraison plus court que la livraison standard, généralement pour les commandes qui ont une certaine priorité" },
    { code: 3, label: "Opération express", description: "Livraison très rapide, souvent pour les commandes qui doivent être livrées dans un délai très court" },
    { code: 4, label: "Opération urgente", description: "Délai de livraison le plus court possible, généralement pour les situations d'urgence ou les commandes critiques" },
  ]
  products: any[] = [
    "xxx 123 - Piéce automobile",
    "yyy 456 - Piéce automobile",
    "zzz 789 - Piéce automobile"
  ]

  client: any = null

  boxform: FormGroup;
  disableBoxForm: boolean = false;
  palletForm: FormGroup;
  disablePalletForm: boolean = false;

  constructor(private fb: FormBuilder,
    private clientService: ClientsService,
    private service: SettingsService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private cmdService: CommandesService) {
    this.boxform = fb.group({
      boxes: fb.array([])
    })
    this.palletForm = fb.group({
      pallets: fb.array([])
    })
  }

  async ngOnInit() {
    await this.getInfosUser()
    // await this._fetchAllSocieties()
    this.allTypePalettes()
    this.getFraisClient()
    this.addNewBoxGroup()
    this.addNewPalletGroup()
  }

  get boxes(): FormArray {
    return this.boxform.get("boxes") as FormArray;
  }
  get pallets(): FormArray {
    return this.palletForm.get("pallets") as FormArray;
  }

  newBoxProduct(index) {
    this.initPalletsData()

   // console.log("box")
    const modalRef = this.modalService.open(AddBoxComponent, { size: 'lg' });
    modalRef.componentInstance.box = {
      "ref": "",
      "t_seak": "",
      "t_hght": null,
      "t_wdth": null,
      "t_dpth": null,
      "ucs": null,
    }

    modalRef.componentInstance.result.subscribe((receivedEntry) => {
      // console.log(receivedEntry)
      if (receivedEntry) {
        // console.log("receivedEntry")
        // console.log(receivedEntry)
        this.client.boxes_products.push(receivedEntry)
        // console.log("Result from modal:", receivedEntry);
        // this._fetchBoxes()

        const add = this.boxform.get('boxes') as FormArray;

        this.mappingSelectedProductValue(receivedEntry, index, add)

        this.disablePalletForm = true
      }
    });
  }

  /** BEGIN UPLOAD FILES */
  onFileSelected(event) {
    const files = event.target.files;
    // console.log(files.length)
    if (files.length > 0) {
      this.cmdService.uploadFiles(files).then((res: any) => {
        this.allFiles.push(...res?.data)
      });
    }
  }
  deleteDoc(index) {
    // console.log(index)
    this.allFiles.splice(index, 1)
  }
  /** END UPLOAD FILES */

  /** BEGIN FUNCTION SOCIETY */
  // async _fetchAllSocieties() {
  //   await this.cmdService.allSocieties().then((res: any) => {
  //     // console.log("resssssssss services : ")
  //     // console.log(res)
  //     if (res) {
  //       this.allSocieties = res;
  //     }
  //   });
  // }
  /** END FUNCTION SOCIETY */

  async allTypePalettes() {
    // console.log("alllll")
    await this.service.allPallets().then((res: any) => {
      // console.log("resssssssss services : ")
      // console.log(res)
      if (res) {
        this.allPalettes = res.data;
      }
    });
  }
  getTypePalette(i) {
    return this.pallets.controls[i].get('id_pallet')?.value
  }
  setTypePalette(event: any, i: number) {
    // console.log(event)
    var typePallet = event //.target.value
    var pallet: any = {
      id_pallet: typePallet
    }
    if (typePallet != "other") {
      this.selectedPalette = this.allPalettes.find((pal) => pal._id === event)
      // console.log(this.selectedPalette)
      pallet.name_pallet = this.selectedPalette.name
      pallet.length = this.selectedPalette.longueur
      pallet.width = this.selectedPalette.largeur
      pallet.height = this.selectedPalette.hauteur
      pallet.volume = this.cmdService.formatNumber(this.selectedPalette.longueur * this.selectedPalette.largeur * this.selectedPalette.hauteur, 3)
    } else {
      pallet.name_pallet = "Autre"
      pallet.length = null
      pallet.width = null
      pallet.height = null
      pallet.volume = null
    }

    this.pallets.at(i).patchValue(pallet);

    this.disableBoxForm = true
  }
  calculPricePalette() {
    // // console.log("dddd")
    // if (this.selectedPalette != null) {
    //   if (this.selectedPalette._id != null) {
    //     if (this.selectedPalette._id == "other") {
    //       if (this.selectedPalette.longueur != null && this.selectedPalette.longueur != ""
    //         && this.selectedPalette.largeur != null && this.selectedPalette.largeur != ""
    //         && this.selectedPalette.hauteur != null && this.selectedPalette.hauteur != "") {
    //         var surfacePalette: any = (this.selectedPalette.longueur / 100) * (this.selectedPalette.largeur / 100)
    //         // console.log("surfacePaletteeeee")
    //         // console.log(surfacePalette)
    //         var percentPalette: any = (surfacePalette.toFixed(3) / 1.2).toFixed(3)
    //         // console.log("percentPaletteeee")
    //         // console.log(percentPalette)

    //         var decimal = Math.floor(percentPalette);
    //         // console.log("decimal")
    //         // console.log(decimal)
    //         var price = decimal * 35
    //         // console.log("decimal * 35")
    //         // console.log(price)

    //         var rest = percentPalette - decimal
    //         // console.log("rest")
    //         // console.log(rest)
    //         /*if (rest > 0 && rest < 0.25) {
    //           price += (35 / 4)
    //         } else */if (rest > 0 && rest <= 0.5) {
    //           price += (35 / 2)
    //         } else {
    //           price += 35
    //         }

    //         // console.log("priceeeeee")
    //         // console.log(price)

    //         this.selectedPalette.price = price

    //         if (this.quantity != null && this.quantity != "" && Number(this.quantity) > 0) {
    //           this.priceTotal = this.quantity * price
    //         } else {
    //           this.priceTotal = null
    //         }
    //       } else {
    //         this.priceTotal = null
    //       }
    //     } else {
    //       this.priceTotal = this.quantity * this.selectedPalette.price
    //     }
    //   }
    // }

    // // if (this.selectedPalette != null && this.selectedPalette._id != null && this.selectedPalette._id == "other"
    // //   && this.selectedPalette.longueur != null && this.selectedPalette.longueur != ""
    // //   && this.selectedPalette.largeur != null && this.selectedPalette.largeur != ""
    // //   && this.selectedPalette.hauteur != null && this.selectedPalette.hauteur != "") {
    // //   var percentPalette = (this.selectedPalette.longueur * this.selectedPalette.largeur) / 1.2

    // //   var price = percentPalette * 35
    // //   this.selectedPalette.price = price

    // //   if (this.quantity != null && this.quantity != "") {
    // //     this.priceTotal = this.quantity * price
    // //   }
    // // }

  }

  /** BEGIN PALLET FORM GROUP */
  addNewPalletGroup() {
    this.pallets.push(this.fb.group({
      id_pallet: [],
      name_pallet: [],
      quantity: [],
      // prix_unitaire: [],
      weight: [],

      length: [],
      width: [],
      height: [],
      volume: 0,

      boxes: this.fb.array([
      ])
    }))
  }
  deletePalletGroup(index: number) {
    this.pallets.removeAt(index);

    if (this.palletForm.value.pallets.length == 0) {
      this.addNewPalletGroup()
      this.disableBoxForm = false
    }

    // if (this.palletForm.value.pallets.length > 1) {
    //   this.pallets.removeAt(index);
    // } else {
    //   if (!this.onePalletNotEmpty(this.palletForm.value.pallets[index])) {
    //     this.pallets.removeAt(index);

    //     this.addNewPalletGroup()
    //   }
    // }
  }
  onePalletNotEmpty(pallet: any) {
    return (pallet.id_pallet == null || pallet.id_pallet == ""
      || pallet.name_pallet == null || pallet.name_pallet == ""
      || pallet.quantity == null || pallet.quantity < 0
      || pallet.weight == null || pallet.weight < 0

      || pallet.length == null || pallet.length < 0
      || pallet.width == null || pallet.width < 0
      || pallet.height == null || pallet.height < 0)
  }
  palletsNotEmpty(pallets) {
    if (pallets.length == 0)
      return false

    for (var i = 0; i < pallets.length; i++) {
      if (this.onePalletNotEmpty(pallets[i])) {
        return false
      }
    }
    return true
  }
  setVolumePallet(i: number) {
    var length = this.pallets.controls[i].get('length')?.value
    var width = this.pallets.controls[i].get('width')?.value
    var height = this.pallets.controls[i].get('height')?.value
    var volume
    if (length && width && height)
      volume = this.cmdService.formatNumber(length * width * height, 3)
    else
      volume = 0

    this.pallets.at(i).patchValue({
      volume: volume
    });
  }
  createBoxesPallet(): FormGroup {
    return this.fb.group({
      // id: [],
      // nom_prod: [],
      // des_prod: [],
      // ucs: [],

      // nbrPcs: [],
      quantite: [],
      weight: [],

      length: [],
      width: [],
      height: [],
      volume: 0
    });
  }
  addContent(boxIndex: number): void {
    const palletGroup = this.pallets.at(boxIndex) as FormGroup;
    const contentsArray = palletGroup.get('boxes') as FormArray;
    contentsArray.push(this.createBoxesPallet());
  }
  deleteBoxPalletGroup(boxIndex, contentIndex: number) {
    const boxGroup = this.pallets.at(boxIndex) as FormGroup;
    const contentsArray = boxGroup.get('boxes') as FormArray;
    // if (contentsArray.length > 1)
    contentsArray.removeAt(contentIndex);
  }
  setVolumeBoxPallet(boxIndex, contentIndex: number) {
    const boxGroup = this.pallets.at(boxIndex) as FormGroup;
    // const contentsArray = boxGroup.get('boxes') as FormArray;

    var contents = this.pallets.controls[boxIndex].get('boxes')?.value
    // console.log(contents)

    var length = contents[contentIndex].length
    var width = contents[contentIndex].width
    var height = contents[contentIndex].height
    var volume
    if (length && width && height)
      volume = this.cmdService.formatNumber(length * width * height, 3)
    else
      volume = 0

    const add = boxGroup.get('boxes') as FormArray;
    add.at(contentIndex).patchValue({
      volume: volume
    });
  }
  /** END PALLET FORM GROUP */

  /** BEGIN BOX FORM GROUP */
  updatePalletQuantity(event, box, i, j) {
    const palletGroup = this.pallets.at(i) as FormGroup;

    const add = palletGroup.get('boxes') as FormArray;

    add.at(j).patchValue({
      quantite: Math.ceil(event.target.value / box.value.ucs)
    });

  }
  updateQuantity(event: any, box: any, index: any) {
    this.initPalletsData()

    // console.log("event.target.value")
    // console.log(event.target.value)

    // console.log("boxxxxx")
    // console.log(box.value)

    const add = this.boxform.get('boxes') as FormArray;
    // console.log("add.at(index).value")
    add.at(index).patchValue({
      quantite: Math.ceil(event.target.value / box.value.ucs)
    });
  }

  selectBoxProductRef(event: any, index: any) {
    this.initPalletsData()

    var valueProduct = this.client.boxes_products
      .find((element: any) => element.ref === event.target.value);

    // var valueProduct = this.client.boxes_products[event.target.value]
    // console.log(valueProduct)

    const add = this.boxform.get('boxes') as FormArray;

    this.mappingSelectedProductValue(valueProduct, index, add)

    this.disablePalletForm = true
  }
  mappingSelectedProductValue(valuePost: any, index: number, contentsArray: any) {
    contentsArray.at(index).patchValue({
      id: valuePost?._id,
      nom_prod: valuePost?.ref,
      des_prod: valuePost?.t_seak,
      ucs: valuePost?.ucs,

      length: valuePost?.t_wdth,
      width: valuePost?.t_dpth,
      height: valuePost?.t_hght,
      volume: valuePost?.volume
    });
  }
  addNewBoxGroup() {
    this.initPalletsData()

    this.boxes.push(this.fb.group({
      id: [],
      nom_prod: [],
      des_prod: [],
      ucs: [],

      nbrPcs: [],
      quantite: [],
      weight: [],

      length: [],
      width: [],
      height: [],
      volume: 0
    }))
  }
  deleteBoxGroup(index: number) {
    this.boxes.removeAt(index);
    this.initPalletsData()

    if (this.boxform.value.boxes.length == 0) {
      this.addNewBoxGroup()
      this.disablePalletForm = false
    }

    // if (this.boxform.value.boxes.length > 1) {
    //   this.boxes.removeAt(index);
    //   this.initPalletsData()
    // } else {
    //   if (!this.oneBoxNotEmpty(this.boxform.value.boxes[index])) {
    //     this.boxes.removeAt(index);
    //     this.initPalletsData()

    //     this.addNewBoxGroup()
    //   }
    // }
  }
  oneBoxNotEmpty(boxe: any) {
    return (boxe.nom_prod == null || boxe.nom_prod == ""
      || boxe.des_prod == null || boxe.des_prod == ""
      || boxe.quantite == null || boxe.quantite < 0
      || boxe.weight == null || boxe.weight < 0

      || boxe.length == null || boxe.length < 0
      || boxe.width == null || boxe.width < 0
      || boxe.height == null || boxe.height < 0)
  }
  oneBoxPalletNotEmpty(boxe: any) {
    return (boxe.quantite == null || boxe.quantite < 0
      || boxe.weight == null || boxe.weight < 0

      || boxe.length == null || boxe.length < 0
      || boxe.width == null || boxe.width < 0
      || boxe.height == null || boxe.height < 0)
  }
  boxesNotEmpty(boxes) {
    if (boxes.length == 0)
      return false

    for (var i = 0; i < boxes.length; i++) {
      if (this.oneBoxNotEmpty(boxes[i])) {
        return false
      }
    }
    return true
  }
  boxesPalletNotEmpty(boxes) {
    if (boxes.length == 0)
      return false

    for (var i = 0; i < boxes.length; i++) {
      if (this.oneBoxPalletNotEmpty(boxes[i])) {
        return false
      }
    }
    return true
  }
  /** END BOX FORM GROUP */

  async getInfosUser() {
    await this.clientService.getUserInfos().then((res: any) => {
      console.log("getUserInfos");
      console.log(res);
      if (res) {
        this.client = res;
        if(this.client?.societies?.length == 1) {
          this.order.society = this.client?.societies[0]?.society?._id
        }
      }
    });
  }
  selectPalletBoxProductRef(event: any, i: number, index: number) {
    var valueProduct = this.client.boxes_products
      .find((element: any) => element.ref === event.target.value);

    const palletGroup = this.pallets.at(i) as FormGroup;

    const add = palletGroup.get('boxes') as FormArray;

    this.mappingSelectedProductValue(valueProduct, index, add)
  }

  selectVille(event: any) {
    this.selectedVille = event.target.value;
  }

  // setTotalCmd() {
  //   this.totalCmd = 0
  //   this.boxform.value.boxes.forEach(prd => {
  //     if (prd.quantite != null && prd.quantite >= 0 && prd.prix_unitaire != null && prd.prix_unitaire >= 0) {
  //       this.totalCmd += prd.quantite * prd.prix_unitaire
  //     }
  //   });
  // }

  setVolumeCmd(i: number) {
    var length = this.boxes.controls[i].get('length')?.value
    var width = this.boxes.controls[i].get('width')?.value
    var height = this.boxes.controls[i].get('height')?.value
    var volume
    if (length && width && height)
      volume = this.cmdService.formatNumber(length * width * height, 3)
    else
      volume = 0

    // const add = this.boxform.get('boxes') as FormArray;
    this.boxes.at(i).patchValue({
      volume: volume
    });
  }

  async calculatePallets(pallet) {
    // console.log(this.boxform.value.boxes)
    var isValidate = this.boxesNotEmpty(this.boxform.value.boxes)
    if (isValidate) {
      await this.cmdService.calculatePallets({
        PALLET_LENGTH: pallet?.longueur,
        PALLET_WIDTH: pallet?.largeur,
        PALLET_HEIGHT: pallet?.hauteur,

        pallet_generated: pallet?._id,

        productList: this.boxform.value.boxes
      })
        .then((res: any) => {
          // console.log("resssssssss : ")
          // console.log(res)
          if (res) {
            if (res?.response) {
              this.palletsData = res?.data
            } else {
              alert(res?.msg);
            }
          } else {
            this.translate.get('data.an_error_occurred')
              .subscribe(async (text: string) => {
                alert(text)
              });
          }
        });
    } else {
      this.translate.get('data.please_add_the_order_boxes')
        .subscribe(async (text: string) => {
          alert(text)
        });
    }
  }

  initCommande() {
    this.boxes.clear()
    this.addNewBoxGroup()

    this.pallets.clear()
    this.addNewPalletGroup()

    this.order = {}
    this.palletsData = []
    this.allFiles = []

    this.isSaved = true
    this.isClicked = false

    this.disableBoxForm = false
    this.disablePalletForm = false
  }
  checkFields() {
    if (this.order.society != null && this.order.society != ""
      && this.order.refFacture != null && this.order.refFacture != ""
      && this.order.priority != null && this.order.priority != "null" && this.order.priority != ""
      && this.order.pickupDate != null && this.order.pickupDate != ""
      && this.order.pickupTime != null && this.order.pickupTime != ""
      && (this.boxesNotEmpty(this.boxform.value.boxes) || this.palletsNotEmpty(this.palletForm.value.pallets))) {
      return true
    } else
      return false
  }
  async addCommande() {
    var isValid = this.checkFields()
    if (!isValid) {
      this.isSaved = false
      this.translate.get('data.order_is_invalid')
        .subscribe(async (text: string) => {
          alert(text)
        });
    } else {
      this.isClicked = true

      if (this.boxesNotEmpty(this.boxform.value.boxes) && this.palletsData?.length == 0) {
        let optionsHtml = this.allPalettes.map(pal => `<option value="${pal?._id}">${pal?.name}</option>`).join('');

        Swal.fire({
          title: 'Sélectionnez le type du palette : ',
          html: `<select id="swal-select" class="swal2-input">${optionsHtml}</select>`,
          focusConfirm: false,
          preConfirm: () => {
            const select = document.getElementById('swal-select') as HTMLSelectElement;
            return select.value;
          }
        }).then((result) => {
          this.isClicked = false
          if (result.isConfirmed) {
            // console.log('Vous avez sélectionné :', result.value);

            var pal = this.allPalettes.find(item => item?._id === result.value)
            this.calculatePallets(pal)
          }
        });
      } else {

        // this.order.totalCmd = this.totalCmd
        if (this.boxesNotEmpty(this.boxform.value.boxes))
          this.order.boxes = this.boxform.value.boxes
        if (this.palletsNotEmpty(this.palletForm.value.pallets))
          this.order.pallets = this.palletForm.value.pallets

        this.order.idExp = await this.clientService.getIdUser()
        this.order.genPallets = this.palletsData
        this.order.uploadDocs = this.allFiles

        await this.cmdService.addCmd(this.order).then((res: any) => {
          // console.log("resssssssss : ")
          // console.log(res)
          if (res) {
            alert(res?.msg);
            this.initCommande()
          } else {
            this.translate.get('data.an_error_occurred')
              .subscribe(async (text: string) => {
                alert(text)
              });
          }
        });
      }
    }
  }

  cleanData(nameDest, adressDest, numTelDest) {
    nameDest.value = ""
    adressDest.value = ""
    numTelDest.value = ""
    this.selectedVille = ""
    // this.totalCmd = 0
    const add = this.boxform.get('boxes') as FormArray;
    while (add.length !== 0) {
      add.removeAt(0)
    }
    this.addNewBoxGroup()
  }

  async getFraisClient() {
    let userId = await this.clientService.getIdUser()
    await this.clientService.getFraisClient(userId)
      .then((res: any) => {
        // console.log("resssssssss :")
        // console.log(res)
        if (res) {
          this.frais = res
          //location.href = '/clients';
          //this.sacsList = res;
        }
      });
  }

  initPalletsData() {
    if (this.palletsData?.length > 0)
      this.palletsData = []
  }

}
